import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1000 324.7"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1434cb",
      d: "M651 1c-71 0-134 36-134 104 0 78 112 83 112 123 0 16-19 31-51 31-46 0-80-21-80-21l-14 69s39 17 91 17c78 0 139-38 139-107 0-83-113-88-113-124 0-13 15-27 48-27 36 0 66 15 66 15l14-67S697 1 651 1zM2 5 0 15s30 6 57 17c35 12 37 20 43 42l64 245h85L380 5h-85l-84 214-35-181c-3-21-19-33-38-33H2zm412 0-67 314h81L495 5h-81zm452 0c-20 0-30 11-38 29L710 319h85l16-47h104l10 47h75L934 5h-68zm11 85 25 118h-67l42-118z"
    }, null, -1)
  ])))
}
export default { render: render }